import { Link } from "react-router-dom";
import { useAuth } from "@/auth/AuthContext";
import BoardWorkspace from "@/components/BoardWorkspace";
import DateTimePreferences from "@/components/DateTimePreferences";
import AppInformationLinks from "@/components/AppInformationLinks";
import "@/styles/data-transfer.css";

export default function SettingsPage() {
  const { user, hasPermission } = useAuth();
  const canManageUsers = hasPermission("users:manage");
  const canViewActivity = user?.role !== "supervisor";
  const canTransfer = ["owner_admin", "office_admin"].includes(user?.role) && hasPermission("imports:manage");
  return <BoardWorkspace eyebrow="Preferences & administration" title="Settings" subtitle="Your account preferences and company administration in one place.">
    <div className="data-settings">
      <section className="data-card" aria-labelledby="my-account-heading">
        <h2 id="my-account-heading">My Account</h2>
        <div className="settings-options">
          <article><h3>Time &amp; Date</h3><p>Choose your date format and display time zone. Project deadlines continue to use the job-site time zone.</p><DateTimePreferences /></article>
          <article><h3>Change Password</h3><p>Update your password. You will sign in again after saving it.</p><Link className="data-link" to="/change-password">Change password</Link></article>
        </div>
      </section>
      {(canManageUsers || canTransfer || canViewActivity) && <section className="data-card" aria-labelledby="company-administration-heading">
        <h2 id="company-administration-heading">Company Administration</h2>
        <div className="settings-options">
          {canManageUsers && <article><h3>Users &amp; Roles</h3><p>Add team members, manage their roles and account access, and reset temporary passwords where permitted.</p><Link className="data-link" to="/settings/users">Manage users</Link></article>}
          {canTransfer && <article><h3>Import &amp; Export</h3><p>Bring in spreadsheets, download readable reports, or review updates to existing records.</p><Link className="data-link" to="/settings/import-export">Open Import &amp; Export</Link></article>}
          {canTransfer && <article><h3>Queue Timing</h3><p>See and, as Owner/Admin, change how long export queue work waits before starting and how long finished files stay available.</p><Link className="data-link" to="/settings/queue-timing">Open Queue Timing</Link></article>}
          {canViewActivity && <article><h3>Activity History</h3><p>Review company project changes, their timestamps, and who made them.</p><Link className="data-link" to="/settings/activity-history">View Activity History</Link></article>}
        </div>
      </section>}
      <AppInformationLinks className="data-card" />
    </div>
  </BoardWorkspace>;
}

